import { Component, OnInit ,ViewChild } from '@angular/core';
import { UntypedFormGroup , UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { chooseOptionsConstant, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { HeadService } from 'src/app/services/common/headservice';
import { Router } from '@angular/router';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { DateObject } from 'src/app/models/common';
import * as $ from 'jquery';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DatePipe } from '@angular/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

@Component({
  selector: 'app-grants-grant-information',
  templateUrl: './grants-grant-information.component.html',
  styleUrls: ['./grants-grant-information.component.scss']
})
export class GrantsGrantInformationComponent implements OnInit , IDeactivateComponent {

  formFields;
  chooseoptions = chooseOptionsConstant;
  grantsInformationForm = new UntypedFormGroup({});
  staticformFields: any;  
  programType: any;
  facultyReceive: any;
  proposedOutcome: any;
  userType: string = "";
  ApplicationID: string;
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Obj_Start_Date: DateObject;
  Obj_End_Date: DateObject;
  StartDate = new Date();
  EndDate = new Date();
  minDate = new Date();
  permission: string = "";
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  grantsapp: any;
  appid: string;
  grantcurrencycode: any = "";
  operations: any = [];
  constructor(
    private router: Router,
    private readonly commonService: CommonService,
    private readonly userService: UserService,
    private modalService : NgbModal,
    public datepipe: DatePipe,
    private summaryService: GrantsSummaryService,
    public grantsDatashare: GrantsDatashareService
  ) {
  this.setFormPermissions();
}

  ngOnInit() {
    this.ApplicationID = this.commonService.appId;
    this.getStaticFiledsData('GC02'); 
    this.getOnIntMethods();
   
    this.grantsapp = this.commonService.getGrantsApp();
    this.appid = this.commonService.appId;
    this.userType = this.userService.getUserType();
    
    debugger;
     if(this.appid==null || this.appid=="" || this.appid==undefined)
     {
       this.NavigateToGenInfo();
     }
    setTimeout(() => {
      this.setFormPermissions();
      if (this.permission == "view") {
        this.grantsInformationForm.disable();
      }
      else 
      {
        this.grantsInformationForm.enable();
      }
    }, 700);
  }

  private setFormPermissions() {     
    this.permission = this.commonService.getPagePermission("GC02");
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
      this.grantsInformationForm.disable();
    }   
  
  if (this.permission == "view") {
    this.grantsInformationForm.disable();
    this.operations = [];
  }
  else {
    this.operations = [
      {
        name: 'SaveGrantInfo', type: 'submit', callback: this.SaveGrantInfo, self: this
      }
    ];
  }
  }
  getOnIntMethods()
  {
    this.grantsInformationForm=new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        APPLICATION_CODE: new UntypedFormControl(""),
        APPLICATION_ID : new UntypedFormControl(""),
        PROGRAM_TYPE: new UntypedFormControl(""),
        PROGRAM_TITLE: new UntypedFormControl(""),
        PROGRAM_DESC: new UntypedFormControl(""),
        PROGRAM_START_DATE: new UntypedFormControl(""),
        PROGRAM_END_DATE: new UntypedFormControl(""),
        REQUEST_AMOUNT: new UntypedFormControl(""),
        TOTAL_AMOUNT: new UntypedFormControl(null),
        ANTICIPATED_REV: new UntypedFormControl(null),
        IS_FACULTY_RECEIVE: new UntypedFormControl(null),
        PROPOSED_OUTCOME: new UntypedFormControl(null),
        EDUCATION_OBJ: new UntypedFormControl(null),
        PROGRAM_START_DATEO: new UntypedFormControl(null),
        PROGRAM_END_DATEO: new UntypedFormControl(null),
        TransactionID : new UntypedFormControl(""),
      }
    )
    this.grantsInformationForm.markAsPristine();
    if(this.permission != "view") {
    }
    else {
      this.grantsInformationForm.disable();
    }
    this.getdata();
  }

  getdata() {
    if (this.ApplicationID != "" && this.ApplicationID != undefined && this.ApplicationID != null) {
      this.summaryService.getGGIData("api/GMGrantsInfo/GetGGIData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
        if (summary != null && summary != undefined && summary != "") {
            this.grantsInformationForm.patchValue(summary);
          

          if (summary["PROGRAM_START_DATE"] != null && summary["PROGRAM_START_DATE"] != "" && summary["PROGRAM_START_DATE"] != undefined) {
          this.StartDate = this.commonService.getdisplayedDate(this.grantsInformationForm.controls["PROGRAM_START_DATE"].value);
          this.grantsInformationForm.controls["PROGRAM_START_DATE"].setValue(this.StartDate);  
          }
          if (summary["PROGRAM_END_DATE"] != null && summary["PROGRAM_END_DATE"] != "" && summary["PROGRAM_END_DATE"] != undefined) {
            this.EndDate = this.commonService.getdisplayedDate(this.grantsInformationForm.controls["PROGRAM_END_DATE"].value);
            this.grantsInformationForm.controls["PROGRAM_END_DATE"].setValue(this.EndDate);  
          }
          this.extendedForm.rowid = summary["ID"];
          this.grantcurrencycode = summary["Currency_Symbol"];
          if(this.grantcurrencycode==null || this.grantcurrencycode==undefined || this.grantcurrencycode=="")
          {
            this.getCurrencyData();
          }
          this.extendedForm.getResponse();
       }
       else{
        this.getCurrencyData();
       }
      });
    }
   
  }
  getCurrencyData()
  {
    this.userService.getGrantCMECurrencySymbol().subscribe(x=>{
      this.grantcurrencycode=x["Data"];
     });
  }
  
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.programType=this.staticformFields["PROGRAM_TYPE"].GROUP_VALUES_LIST;
        this.programType = [{ label: "Select", value: null, checked: true }].concat(this.programType);
        this.facultyReceive=this.staticformFields["IS_FACULTY_RECEIVE"].GROUP_VALUES_LIST;
        this.facultyReceive = [{ label: "Select", value: null, checked: true }].concat(this.facultyReceive);
        this.proposedOutcome = this.staticformFields["PROPOSED_OUTCOME"].GROUP_VALUES_LIST;
        this.proposedOutcome = [{ label: "Select", value: null, checked: true }].concat(this.proposedOutcome);
      }
    );
  }
  onCallbackOperation(opr){
    opr.callback();
  }
  SaveGrantInfo() {
    if(this.validateControls()){
      var formData= this.grantsInformationForm.value;
      formData.APPLICATION_ID=this.ApplicationID;
      if (formData["TOTAL_AMOUNT"] != null && formData["TOTAL_AMOUNT"] != undefined) {
      formData["TOTAL_AMOUNT"] = parseInt(this.grantsInformationForm.controls["TOTAL_AMOUNT"].value);
      }
      if (formData["REQUEST_AMOUNT"] != null && formData["REQUEST_AMOUNT"] != undefined) {
      formData["REQUEST_AMOUNT"] = parseInt(this.grantsInformationForm.controls["REQUEST_AMOUNT"].value);
      }
      formData["StartDateObj"]=this.GetStartDate();
      formData["EndDateObj"]=this.GetEndDate();
      if(formData.ID == null || formData.ID == "" || formData.ID == undefined ) {
            this.summaryService.SaveCMEGrantInfo("api/GMGrantsInfo/Insert", formData).subscribe(summary => {
                if (summary.Status === 0 ) {
                  this.grantsInformationForm.controls["ID"].setValue(summary.TransactionID);
                  this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result => {
                    if (result.Status === 0) {
                      this.commonService.SuccessBanner(summary.Message);
                      if(this.extendedForm!=null && this.extendedForm!=undefined)
                      {
                        this.extendedForm.rowid=summary.TransactionID;
                        this.extendedForm.IsFormToched=false;
                        this.extendedForm.getResponse();
                      }
                      this.grantsInformationForm.markAsPristine();
                    }
                    else {
                      this.commonService.ValidationBanner(result.Message);
                    }
                  });
                }
                else{
                  this.commonService.ValidationBanner(summary.Message);
                }
            });
      } 
      else{
        this.summaryService.SaveCMEGrantInfo("api/GMGrantsInfo/Update", formData).subscribe(summary => {
          if (summary.Status === 0 || summary.ErrorCode === "NOCHANGES") {
            this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result => {
              if (result.ErrorCode === "NOCONTROLS") {
                  if (summary.Status === 0 ){
                    this.commonService.SuccessBanner(summary.Message);
                    this.extendedForm.IsFormToched=false;
                    this.grantsInformationForm.markAsPristine();
                  }                  
                  else {
                    this.commonService.ValidationBanner(summary.Message);
                  }
              }
              else {
                if (summary.ErrorCode === "NOCHANGES" && result.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(summary.Message);
                } else {
                  this.commonService.SuccessBanner("Grants Information saved Successfully");
                  this.grantsInformationForm.markAsPristine();
                  if (this.extendedForm != null && this.extendedForm != undefined) {
                    this.extendedForm.IsFormToched=false;
                    this.extendedForm.rowid = summary.TransactionID;
                    this.extendedForm.getResponse();
                  }
                }
              }
            });
        }
        else {
          this.commonService.ValidationBanner(summary.Message);
        }
      });
      }
    }
  } 

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Obj_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Obj_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {

      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }

  GetStartDate(): DateObject {
    var formModel = this.grantsInformationForm.getRawValue();
    const lDate = new Date(formModel.PROGRAM_START_DATE);
    if ((this.CompareDates(this.StartDate, lDate) || this.Obj_Start_Date == null || this.Obj_Start_Date == undefined) && formModel.PROGRAM_START_DATE) {
      this.Obj_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else{
      this.Obj_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Obj_Start_Date
  }

  GetEndDate(): DateObject {
    const formModel = this.grantsInformationForm.getRawValue();
    const lDate = new Date(formModel.PROGRAM_END_DATE);
    if ((this.CompareDates(this.EndDate, lDate) || this.Obj_End_Date == null || this.Obj_End_Date == undefined) && formModel.PROGRAM_END_DATE != null)
      this.Obj_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
      else{
        this.Obj_End_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: true,
          HasValue: true,
          IsDateModified: true
        }
      }
    return this.Obj_End_Date;
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.grantsInformationForm.value;

    if (this.staticformFields?.PROGRAM_TYPE.IS_MANDATORY && this.staticformFields?.PROGRAM_TYPE.IS_Display) {
      if (formData.PROGRAM_TYPE === null || formData.PROGRAM_TYPE === "") {
        $("#PROGRAM_TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_TYPE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_TITLE.IS_MANDATORY && this.staticformFields?.PROGRAM_TITLE.IS_Display) {
      if (formData.PROGRAM_TITLE === null || formData.PROGRAM_TITLE === "") {
        $("#PROGRAM_TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.PROGRAM_TITLE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_TITLE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_DESC.IS_MANDATORY && this.staticformFields?.PROGRAM_DESC.IS_Display) {
      if (formData.PROGRAM_DESC === null || formData.PROGRAM_DESC === "") {
        $("#PROGRAM_DESC").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_DESC").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.PROGRAM_DESC.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_DESC").addClass("ng-untouched ng-valid");
        $("#PROGRAM_DESC").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_START_DATE.IS_MANDATORY && this.staticformFields?.PROGRAM_START_DATE.IS_Display) {
      if (formData.PROGRAM_START_DATE === null || formData.PROGRAM_START_DATE === "" || formData.PROGRAM_START_DATE == undefined) {
        $("#PROGRAM_START_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_START_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_START_DATE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_START_DATE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_START_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_END_DATE.IS_MANDATORY && this.staticformFields?.PROGRAM_END_DATE.IS_Display) {
      if (formData.PROGRAM_END_DATE === null || formData.PROGRAM_END_DATE === "" || formData.PROGRAM_END_DATE == undefined) {
        $("#PROGRAM_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_END_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_END_DATE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_END_DATE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_END_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.REQUEST_AMOUNT.IS_MANDATORY && this.staticformFields?.REQUEST_AMOUNT.IS_Display) {
      if (formData.REQUEST_AMOUNT === null || formData.REQUEST_AMOUNT === "" || formData.REQUEST_AMOUNT == undefined) {
        $("#REQUEST_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUEST_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REQUEST_AMOUNT").addClass("ng-untouched ng-valid");
        $("#REQUEST_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TOTAL_AMOUNT.IS_MANDATORY && this.staticformFields?.TOTAL_AMOUNT.IS_Display) {
      if (formData.TOTAL_AMOUNT === null || formData.TOTAL_AMOUNT === "" || formData.TOTAL_AMOUNT == undefined) {
        $("#TOTAL_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#TOTAL_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TOTAL_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#TOTAL_AMOUNT").addClass("ng-untouched ng-valid");
        $("#TOTAL_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ANTICIPATED_REV.IS_MANDATORY && this.staticformFields?.ANTICIPATED_REV.IS_Display) {
      if (formData.ANTICIPATED_REV === null || formData.ANTICIPATED_REV === "" || formData.ANTICIPATED_REV == undefined) {
        $("#ANTICIPATED_REV").addClass("ng-touched ng-invalid validate-error");
        $("#ANTICIPATED_REV").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ANTICIPATED_REV.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ANTICIPATED_REV").addClass("ng-untouched ng-valid");
        $("#ANTICIPATED_REV").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.IS_FACULTY_RECEIVE.IS_MANDATORY && this.staticformFields?.IS_FACULTY_RECEIVE.IS_Display) {
      if (formData.IS_FACULTY_RECEIVE === null || formData.IS_FACULTY_RECEIVE === "" || formData.IS_FACULTY_RECEIVE == undefined) {
        $("#IS_FACULTY_RECEIVE").addClass("ng-touched ng-invalid validate-error");
        $("#IS_FACULTY_RECEIVE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.IS_FACULTY_RECEIVE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#IS_FACULTY_RECEIVE").addClass("ng-untouched ng-valid");
        $("#IS_FACULTY_RECEIVE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROPOSED_OUTCOME.IS_MANDATORY && this.staticformFields?.PROPOSED_OUTCOME.IS_Display) {
      if (formData.PROPOSED_OUTCOME === null || formData.PROPOSED_OUTCOME === "" || formData.PROPOSED_OUTCOME == undefined) {
        $("#PROPOSED_OUTCOME").addClass("ng-touched ng-invalid validate-error");
        $("#PROPOSED_OUTCOME").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROPOSED_OUTCOME.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROPOSED_OUTCOME").addClass("ng-untouched ng-valid");
        $("#PROPOSED_OUTCOME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.EDUCATION_OBJ.IS_MANDATORY && this.staticformFields?.EDUCATION_OBJ.IS_Display) {
      if (formData.EDUCATION_OBJ === null || formData.EDUCATION_OBJ === "" || formData.EDUCATION_OBJ == undefined) {
        $("#EDUCATION_OBJ").addClass("ng-touched ng-invalid validate-error");
        $("#EDUCATION_OBJ").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.EDUCATION_OBJ.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#EDUCATION_OBJ").addClass("ng-untouched ng-valid");
        $("#EDUCATION_OBJ").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    var StartDate = formData.PROGRAM_START_DATE;
    var EndDate = formData.PROGRAM_END_DATE;
    var eDate = new Date(EndDate);
    var sDate = new Date(StartDate);
    if (this.staticformFields?.PROGRAM_START_DATE.IS_Display && this.staticformFields?.PROGRAM_START_DATE.IS_MANDATORY
      && this.staticformFields?.PROGRAM_END_DATE.IS_Display && this.staticformFields?.PROGRAM_END_DATE.IS_MANDATORY) {
      if (StartDate != '' && StartDate != null && StartDate != undefined && EndDate != null && EndDate != '' && EndDate != undefined && sDate > eDate) {
        message = message + `${this.staticformFields?.PROGRAM_END_DATE.LABEL_NAME} cannot be lesser than  ${this.staticformFields?.PROGRAM_START_DATE.LABEL_NAME} Please update the details </br>`;
        isValid = false;
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }
    if(!isValid){
      this.commonService.ValidationBanner(message)
    }
    return isValid;
  }

  NavigateToGenInfo(){
      this.appid = this.commonService.appId;
      let Menumodule=this.commonService.getModuleMenu();
      if (this.appid == null || this.appid == undefined || this.appid == "") {
        const modalRefAcc = this.modalService.open(MessageBoxComponent, {});
        modalRefAcc.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Grants Information', operation: { hasConfirm: false } } };
        modalRefAcc.result.then((result) => {
          this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/geninfocme'],
            { skipLocationChange: true, queryParams: { id: 0, app_ext: true, module: "grants",submodule:Menumodule.module, screen_type: "my-applications" } })
        });
        return false;
      }
  }

  canExit() {
    if (this.grantsInformationForm.dirty || this.extendedForm.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
